import { VideoImage } from '../VideoContent';
import Icon from '../Icon';

const Demo6Content2 = () => {
    return (
        <section id="content-2" className="content-2 wide-60 content-section division">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-md-5 col-lg-6">
                        <div className="rel img-block left-column video-preview wow fadeInRight">
                            <VideoImage img="/images/demo6/img-08.png" />
                        </div>
                    </div>
                    <div className="col-md-7 col-lg-6">
                        <div className="txt-block right-column wow fadeInLeft">
                            <div className="txt-box mb-20">
                                <h5 className="h5-lg">All Tools in One Place</h5>
                                <p className="p-lg">
                                    Rush Studio brings together valid translation memory, automated workflows, and team collaboration into a single, unified platform. Stop switching between tools and start delivering content faster.
                                </p>
                            </div>
                            <hr />
                            {[
                                'Seamless Figma Integration',
                                'Real-time collaborative editing',
                                'Automated quality checks',
                                'Centralized glossary management',
                            ].map((text) => (
                                <div key={text} className="cbox-3 mb-10">
                                    <div className="cbox-3-ico ico-15">
                                        <Icon symbol="✓" decorative className="icon-check purple-color" />
                                    </div>
                                    <div className="cbox-3-txt">
                                        <h6 className="h6-lg">{text}</h6>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Content2;
